<template>
  <div>
    <vx-card class="mb-2" >
      <vs-row class="" vs-align="center" vs-justify="space-between">
        <vs-col vs-w="3" >
          <div>
            <h4>Kit Id {{isValidKit ? `: ${kitId} ` : 'To Be Replaced'}}</h4>
          </div>
        </vs-col>
        <vs-col vs-w="6">
          <div v-if="isValidKit">
            <vs-button class="float-right" @click="reset()">Replace different kit</vs-button>
          </div>
          <!-- SEARCH INPUT -->
          <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
            v-else
            type="text"
            :danger="!!errorMessage.length"
            :danger-text="errorMessage"
            val-icon-danger="error_outline"
            @keyup="inputValue = inputValue.toUpperCase()"
            placeholder="Kit Id..."
            size="large"
            v-model="inputValue"
            v-on:keyup.enter="validateKit()"
          />
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import dnaApi from "@/http/dnaApi";

export default {
  props: [
    'isLoading',
    'next',
    'kitId',
    'userId'
  ],
  data() {
    return {
      inputValue: null,
      errorMessage: "",
      isValidKit: false
    }
  },
  methods: {
    async validateKit() {
      this.errorMessage = "";
      this.isValidKit = false;
      this.$emit('update:isLoading', true);

      const invalidStatuses = ['PROCESSING_STARTED', 'GENOTYPES_READY', 'REPORT_READY'];
      const ggKit = await dnaApi.getGGKit(this.inputValue);
      const dnaKit = await dnaApi.getKitByKitId(this.inputValue);

      if(!ggKit) {
        this.$emit('update:isLoading', false);
        return this.errorMessage = 'Kit not found!';
      }

      if(invalidStatuses.includes(ggKit.status) || dnaKit && dnaKit.oldUserId) {
        this.$emit('update:isLoading', false);
        return this.errorMessage = `Kit isn't eligible to be replaced. Status: ${ggKit.status}. ${dnaKit.oldUserId ? "Kit has already been replaced" : null}`;
      }

      this.isValidKit = true;
      this.$emit('update:kitId', ggKit.kitId.toUpperCase());
      this.$emit('update:userId', dnaKit && dnaKit.userId || null);
      this.$emit('update:isLoading', false);
      this.next();
    },
    reset() {
      this.inputValue = "";
      this.errorMessage = "";
      this.$emit('update:kitId', null);
      this.isValidKit = false;
      this.next(true);
    }
  }
}
</script>
